<div class="manage-workflows-container">

  <section class="manage-workflows-container-titlebar">
    <div class="titlebar-left">
      <h3><i class="fa-regular fa-diagram-project"></i> Workflows</h3>
      <p>
        Edit your workflows and AI agents. You can create new workflows, modify existing ones, and manage how your AI
        agents interact with users and data.
      </p>
    </div>
    <div class="titlebar-right">

      <!-- <button
              nz-button
              nz-tooltip
              [nzTooltipTitle]="'Display data tables'"
              nzType="default"
              nzSize="small"
              class="tables-home-button"
              (click)="onDbHomeButtonClicked()">
        <i class="fa-regular fa-table"></i>&nbsp;All Tables
      </button> -->
    </div>

  </section>

  <div class="ui-management-cards">

    <!-- <h4 class="p-2x title">Workflows</h4>
    <p class="title-description">Design and manage agentic AI workflows to automate processes and integrate with external services.</p> -->

    <rappider-card-icon-title-description-list [items]="(uiManagementCards ?? []).concat(starterWorkflowCards ?? [])"
                                               (cardClick)="onUiManagementCardCardClicked($event)">
    </rappider-card-icon-title-description-list>

  </div>
  <!-- <div class="ui-management-cards">

    <h4 class="p-2x title">Edit Workflows</h4>
    <p class="title-description">Edit the layout and content of your workflows</p>

    <rappider-card-icon-title-description-list [items]="uiPageCards"
                                               (cardClick)="onUiPageCardCardClicked($event)">
    </rappider-card-icon-title-description-list>

  </div> -->

</div>
